<div class="header">
  <div>
    <h2>
      Add Seeder Data
    </h2>
    <p>
      Create roles and assign permissions. These roles will be used when generating demo users and their access levels.
    </p>
  </div>

  <button class="add-btn"  (click)="toggleModal('add')">
    <img src="assets/images/PlusIcon.svg" alt="" />
    Add Seeders
  </button>
</div>

<div class="rp-body">
  <div class="table-wrapper">
    <table>
      <thead>
        <!-- <tr>
          <th>User Name</th>
          <th>Email</th>
          <th>Role</th>
          <th class="text-right pr-4">Status</th>
        </tr> -->
      </thead>
      <tbody *ngIf="loading || showSkeleton">
        <tr *ngFor="let row of skeletonRows">
          <td *ngFor="let col of skeletonCols">
            <div class="skeleton-cell"></div>
          </td>
        </tr>
      </tbody>

      <!-- REAL DATA BODY -->
      <!-- <tbody *ngIf="!loading && !showSkeleton">
        <tr>
          <td>John Doe</td>
          <td>john@example.com</td>
          <td>Admin</td>
          <td class="text-right pr-4">Active</td>
        </tr>
        <tr>
          <td>Jane Smith</td>
          <td>jane@example.com</td>
          <td>Manager</td>
          <td class="text-right pr-4">Active</td>
        </tr>
        <tr>
          <td>Bob Johnson</td>
          <td>bob@example.com</td>
          <td>Employee</td>
          <td class="text-right pr-4">Active</td>
        </tr>
      </tbody> -->
    </table>
  </div>
</div>

<app-add-popup *ngIf="showconformModal" title="Add Seeder Data"
  subtitle="Are you sure you want to add Seeder Data? This action cannot be undone."
  iconPath="assets/images/deleteicon.svg" (close)="toggleModal('delete')">
  <div class="modal-footer justify-center">
    <button type="button" class="btn-cancel" (click)="toggleModal('delete')">
      Cancel
    </button>
    <button type="button" class="btn-save" (click)="confirmSave()">
      <span></span>Confirm
    </button>
  </div>
</app-add-popup>